import configurationComponent from "./configuration.component";


let configurationModule = angular.module('configuration', [

])

    .component('configuration', configurationComponent)

    .config(($stateProvider, $urlRouterProvider) => {
        'ngInject';
        // $stateProvider
            // .state('billable_events.all', {
            //     url: '/all/:page',
            //     component: 'configurationAll',
            //     data: {
            //         requireLogin: true,
            //         requireACL: 'tnt_billing_billable_events.view'
            //     },
            // })
    })
    .name;

export default configurationModule;



// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/configuration/index.js